import { useLocation, useNavigate, useParams } from "react-router-dom";
import { OrderSummaryMain } from "../OrderSummary/OrderSummaryMain";
import { PayOnlineOrderDetails } from "./PayOnlineOrderDetails";
import { GreetingContainer } from "../BillInfo/greetingContainer";
import { useAuth } from "../../Context/AuthContext";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../Context/pleaseNote";
import { Link } from "react-router-dom";
import { OrderConfirmationSkeleton } from "../../Skeleton/orderConfirmationSkeleton";
import {
  isNumeric,
  isValidArray,
  scrollToTop,
  showCardDetails,
  validateMonthYear,
  smsNumberChangeClick,
  scrollToFocuse,
} from "../../Layout/Common/common";
import { PaymentSection } from "../CheckOutNew/Payment/paymentMethod/paymentSection";
import { PAGES } from "../../routeConfig";
import { SUBMIT_ORDER, getTillBrowserData } from "../../constants";
import { redirectToTill, readTillBackPath } from "../../Context/hook/tillRedirect";
import { useTillReturnSettlement } from "../../Context/hook/useTillReturnSettlement";
import { useTillReturnBackGuard } from "../../Context/hook/useTillReturnBackGuard";
import { TillSettlingOverlay } from "../../Layout/Common/tillSettlingOverlay";
import { useCheckPoNumberRules } from "../../Context/hook/useCheckPONumberRules";
import { PaymentSectionPayOnline } from "./paymentSectionPayOnline";
import {
  BANKTRANSFER_TERM,
  MASTERCARD_TERM,
  ONACCOUNT_TERM,
  PAYMENT_FAILED,
  PAYMENT_RESTRICT_ROLE,
  SHIPPING_METHOD,
} from "../../constants";
import { GlobalContext } from "../../Context/GlobalContext";
import { set, upperCase } from "lodash";
import Skeleton from "react-loading-skeleton";
import $ from "jquery";
import { InvalidReferenceId } from "./inValidReferenceId";
import { PayOnlineSkeleton } from "../../Skeleton/payOnlineSkeleton";
import { BacktoPrevious } from "../MyAccount/backtoPrevious";

export const PayOnlineMain = ({ orderRef } = {}) => {
  const { urlref } = useParams();
  const effectiveOrderId = urlref ?? orderRef;
  const { userId } = useAuth();
  const [billInfo, setBillInfo] = useState(null);
  const { loadStoredCard } = useGlobalFunction();
  const { showFlashScreen, showRestrictionAlert, hideNoteAlert, showDialogAlert } = useNoteAlert();
  const history = useNavigate();
  const location = useLocation();
  const paymentData = location.state;
  const { settling, tillReturn } = useTillReturnSettlement();
  const tillHandledRef = useRef(false);
  const [paybuttonDisabled, setPaybuttonDisabled] = useState(false);
  const [tillToken, setTillToken] = useState(null);
  const [showLoading, setShowLoading] = useState(true);
  const [tillProcess, setTillProcess] = useState(false);
  const [smsNumberCancelClicked, setSmsNumberCancelClicked] = useState(false);
  const { submitOrderMailSend } = useGlobalFunction();
  const { showNoteAlert } = useNoteAlert();
  const checkPoNumberRules = useCheckPoNumberRules();
  const divcontainerRef = useRef();
  const {
    poNumber,
    poNumberRequired,
    poNumberRules,
    selectedPaymentType,
    setSelectedPaymentType,
    deliveryMethod,
    orderCommands,
    shippingMode,
    shippingCode,
    changeShipServiceClicked,
    selectedCard,
    promoCode,
    isSubmitOrder,
    newCardSave,
    setNewcardSave,
    setDeliveryMethod,
    smsNumber,
    smsNotificationCancelClicked,
    globalcontext,
  } = useContext(GlobalContext);
  const [paymentType, setPaymentType] = useState("NEWCARD");

  useTillReturnBackGuard({
    active: !!tillReturn && !settling,
    backTo: readTillBackPath() || (userId ? PAGES.ORDERHISTORY : PAGES.HOME),
  });

  useEffect(() => {
    if (changeShipServiceClicked == false) scrollToFocuse(divcontainerRef.current, 500, 200);

    return () => {
      setSelectedPaymentType(null);
      setNewcardSave(false);
    };
  }, [changeShipServiceClicked]);

  useEffect(() => {
    scrollToTop();
    showFlashScreen(false);
    if (effectiveOrderId) {
      setShowLoading(true);
      loadStoredCard();
      axiosInstance
        .post("Payonline/GetBillInfo", {
          userId: String(userId),
          orderId: String(effectiveOrderId),
        })
        .then((response) => {
          if (response.data && response.data.orderItem) {
            if (response.data.orderInfo.OrderStatus != 18) {
              setBillInfo(null);
            } else setBillInfo(response.data);
          }
        })
        .catch((error) => {
          setBillInfo(null);
        })
        .finally(() => {
          setShowLoading(false);
        });
    }
  }, [effectiveOrderId]);

  useEffect(() => {
    if (selectedPaymentType) {
      setTillToken(null);
    }
  }, [selectedPaymentType]);

  const handlePayNowClick = () => {
    if (String(deliveryMethod).includes(SHIPPING_METHOD[2]) && !smsNumber && smsNumberCancelClicked == false) {
      showDialogAlert({
        content: "Please provide a mobile number to receive SMS notification or proceed without SMS notification.",
        title: "SMS Notification Not Provided",
        primaryBtn: {
          caption: "Provide Mobile Number",
          onClick: () => smsNumberChangeClick(),
        },
        scondaryBtn: {
          caption: "Proceed without SMS",
          onClick: () => {
            setSmsNumberCancelClicked(true);
            checkOrderNumber();
          },
        },
      });
    } else {
      checkOrderNumber();
    }
  };

  const checkOrderNumber = () => {
    PayNow();
  };

  useEffect(() => {
    if (settling || !tillReturn || tillReturn.isSuccess || tillHandledRef.current) return;
    tillHandledRef.current = true;
    showDialogAlert({
      content: PAYMENT_FAILED.content,
      title: PAYMENT_FAILED.title,
      primaryBtn: { caption: "Try new card", onClick: paymentDeclineFunction },
      scondaryBtn: { caption: "Ok", onClick: hideNoteAlert },
    });
  }, [settling, tillReturn]);

  const paymentDeclineFunction = () => {
    setTillToken(null);
    setSelectedPaymentType("NEWCARD");
    $("#newCardPayment").click();
    showCardDetails();
    hideNoteAlert();
  };

  const getCardUuid = () => {
    if (selectedCard && selectedPaymentType == "MYWALLET") {
      return selectedCard.cardUuid;
    } else {
      return "";
    }
  };

  const ProcessPayment = (trntoken) => {
    var params = {
      userId: userId ? String(userId) : "",
      orderId: String(billInfo.orderInfo.OrderID),
      mobileNumber: "",
      amount: String(billInfo.totalAmount),
      shipNotes: orderCommands,
      shippingAddress: billInfo.shippingAddress,
      shipcode: billInfo.shipCode,
      shipcost: String(billInfo.shipCost),
      orderCommands: orderCommands,
      transaction_token: trntoken,
      addressType: "",
      signRequired: false,
      isSaveCard: newCardSave,
      uuid: getCardUuid(),
      paymentMode: selectedPaymentType || "ORDER SUBMIT",
      cardType: selectedPaymentType,
      grossAmount: String(billInfo.orderItem.totalcost),
      totalTax: String(billInfo.totalAmount),
      deliveryMethod: billInfo.shipMethod || deliveryMethod,
      shippingService: billInfo.shipMethod || deliveryMethod,
      purchaseOrderNumber: poNumber,
      promoCode: promoCode,
      returnPath: window.location.pathname,
      browserData: getTillBrowserData(),
    };

    if (selectedPaymentType == "MYWALLET" || selectedPaymentType == "NEWCARD") {
      params.paymentMode = "TI";
    }

    // if (globalcontext.IsInterNational == false) {
    //   if (params.paymentMode.toUpperCase() != "TI") {
    //     globalcontext.setUuid("0");
    //   }

    //   if (
    //     globalcontext.addressType == ChangeOfAddressType.changeOfAddress ||
    //     globalcontext.addressType == ChangeOfAddressType.dropShippment
    //   ) {
    //     if (globalcontext.addressType == ChangeOfAddressType.changeOfAddress) params.addressType = "A";
    //     if (globalcontext.addressType == ChangeOfAddressType.dropShippment) params.addressType = "D";
    //     if (globalcontext.shippingAddress) {
    //       params.shippingAddress = globalcontext.shippingAddress;
    //       params.signRequired = globalcontext.shippingAddress.signatureRequired;
    //     }
    //   }
    // }
    axiosInstance
      .post("Payonline/SaleTransTI", params)
      .then((response) => {
        if (response.data != "" && response.data != null) {
          showFlashScreen(false);
          if (response.data.Status == "Success") {
            if (params.paymentMode == "TI") {
              showFlashScreen({
                messages: ["Taking you to the secure payment page…", "Please do not refresh or close this window."],
              });
              redirectToTill(response.data.RedirectTo);
            } else {
              submitOrderMailSend(response.data.orderid);
              history("/BillInfo/" + response.data.RedirectTo);
            }
          } else if (response.data.Status == "Error01") {
            history(PAGES.ORDER_DETAIL);
            showFlashScreen(false);
          } else if (response.data.Status == "Error02") {
            showFlashScreen(false);
            showNoteAlert("Your price code has been changed. Please verfiy the price and continue.");
            window.location.reload();
            //setPriceCodePopup(true);
          } else {
            showNoteAlert("Payment Process Failed. Please try again.");
            showFlashScreen(false);
          }
        }
      })
      .catch((error) => {
        showFlashScreen(false);
      });
  };

  // Google Pay: run the same pre-pay checks as the card "Pay Now" (SMS number prompt) before opening
  // the Google Pay sheet. `proceed` opens the sheet; it is only called once validation passes.
  const handleGooglePayBeforePay = (proceed) => {
    if (String(deliveryMethod).includes(SHIPPING_METHOD[2]) && !smsNumber && smsNumberCancelClicked == false) {
      showDialogAlert({
        content: "Please provide a mobile number to receive SMS notification or proceed without SMS notification.",
        title: "SMS Notification Not Provided",
        primaryBtn: {
          caption: "Provide Mobile Number",
          onClick: () => smsNumberChangeClick(),
        },
        scondaryBtn: {
          caption: "Proceed without SMS",
          onClick: () => {
            setSmsNumberCancelClicked(true);
            proceed();
          },
        },
      });
    } else {
      proceed();
    }
  };

  const processGooglePayToken = (googlePayToken) => {
    showFlashScreen({
      messages: [
        "Processing your order, please wait…",
        "Confirming your Google Pay details with Till…",
        "Authorising your payment…",
        "Please do not refresh or close this window.",
      ],
    });
    var params = {
      userId: userId ? String(userId) : "",
      orderId: String(billInfo.orderInfo.OrderID),
      mobileNumber: "",
      amount: String(billInfo.totalAmount),
      shipNotes: orderCommands,
      shippingAddress: billInfo.shippingAddress,
      shipcode: billInfo.shipCode,
      shipcost: String(billInfo.shipCost),
      orderCommands: orderCommands,
      transaction_token: "",
      addressType: "",
      signRequired: false,
      isSaveCard: false,
      uuid: "0",
      paymentMode: "GOOGLEPAY",
      cardType: "TILLGOOGLEPAY",
      grossAmount: String(billInfo.orderItem.totalcost),
      totalTax: String(billInfo.totalAmount),
      deliveryMethod: billInfo.shipMethod || deliveryMethod,
      shippingService: billInfo.shipMethod || deliveryMethod,
      purchaseOrderNumber: poNumber,
      promoCode: promoCode,
      googlePayToken: googlePayToken,
    };
    axiosInstance
      .post("Payonline/ProcessGooglePay", params)
      .then((response) => {
        const data = typeof response?.data === "string" ? JSON.parse(response.data) : response?.data;
        showFlashScreen(false);
        if (!data?.successful) {
          if (data?.redirectUrl) {
            window.location.href = data.redirectUrl; // 3DS challenge
            return;
          }
          showNoteAlert(data?.error || "Payment Process Failed. Please try again.");
          return;
        }
        history("/BillInfo/" + data.redirectRef);
      })
      .catch((error) => {
        showFlashScreen(false);
        showNoteAlert("We couldn't reach Till to complete your payment. Please check your connection and try again.");
      });
  };

  const PayNow = () => {
    showFlashScreen(true);
    if (selectedPaymentType == "NEWCARD") {
      GenerateToken();
    } else if (selectedPaymentType == "MYWALLET") {
      ProcessPayment("");
    } else {
      showFlashScreen(false);
      showNoteAlert("Please select a valid payment method before proceeding.");
    }
  };

  const GenerateToken = () => {
    var validation = true;
    var cardName = document.getElementById("cardName")?.value ?? "";
    var cardExp = document.getElementById("cardExp")?.value ?? "";

    if (isNumeric(cardName) == false) {
      showFlashScreen(false);
      $("#newcardNameError").css("display", "block");
      $("#cardName").focus();
      validation = false;
    }
    var isv = 1;
    if (!validateMonthYear(cardExp)) {
      isv = 0;
      showFlashScreen(false);
      $("#newcardExpError").css("display", "block");
      if (validation == false) $("#cardExp").focus();
      validation = false;
    }
    if (validation) {
      var splitval = cardExp.split("/");
      var data = {
        card_holder: cardName,
        month: splitval[0],
        year: "20" + splitval[1],
      };
      window.till.tokenize(
        data,
        function (token, cardData) {
          var isdefault = "0";
          setTillToken(token);
          ProcessPayment(token);
        },
        function (errors) {
          if (errors) {
            if (isValidArray(errors)) {
              var errmsg = errors[0].message;
              if (errmsg) {
                showNoteAlert(errmsg);
              } else {
                showNoteAlert("Payment process failed. Please try again.");
              }
            }
          }
          showFlashScreen(false);
        },
      );
    } else {
      showNoteAlert("Please fill in the mandatory fields and try again.");
      showFlashScreen(false);
    }
  };
  const GetPamentType = () => {
    if (selectedPaymentType == "BT") setPaymentType("BT");
  };

  return (
    <Fragment>
      <TillSettlingOverlay show={settling} message="Confirming your payment..." />
      {showLoading ? (
        <PayOnlineSkeleton />
      ) : billInfo ? (
        <section className="checkout-section">
          <div className="container-fluid container-lg">
            <div className="row row-equal">
              <div className="col-md-7 col-lg-7 checkout-left">
                <div className="row">
                  <div className="col-lg-12 checkout-lft-title">
                    <div className="wesproduct-title cart-title">
                      <div>
                        <h1 className="myaccount-title mb-2">Order Invoice #:{billInfo.orderInfo.InvoiceNo ?? ""}</h1>
                        <div className="order-invoice">
                          <p>
                            Customer Order Number: <span>{billInfo.poNumber}</span>
                          </p>
                          <p>
                            Invoice Date:
                            <span>
                              {(() => {
                                const d = new Date(billInfo.orderInfo.CreatedDate);
                                if (isNaN(d)) return billInfo.orderInfo.CreatedDate;
                                const day = String(d.getDate()).padStart(2, "0");
                                const month = String(d.getMonth() + 1).padStart(2, "0");
                                const year = d.getFullYear();
                                return `${day}-${month}-${year}`;
                              })()}
                            </span>
                          </p>
                        </div>
                      </div>
                      <BacktoPrevious />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="delivery-method">
                      <PayOnlineOrderDetails billInfo={billInfo} />

                      {String(billInfo.payInfo.paymentResponse).toUpperCase() != "YES" &&
                        billInfo.orderInfo.OrderStatus == 18 && (
                          <Fragment>
                            <PaymentSectionPayOnline
                              TotalAmount={billInfo.totalAmount}
                              is_payAccount={false}
                              orderId={billInfo.orderInfo.OrderID}
                              walletCount={billInfo.myWalletCount}
                              onGooglePayBeforePay={handleGooglePayBeforePay}
                              onGooglePayToken={processGooglePayToken}
                            />

                            {/* Google Pay keeps the Total on show — same as checkout and PayAccount —
                                and only swaps out the Pay Now button, which its own button replaces. */}
                            {selectedPaymentType != "BT" && (
                              <div className="total-amount-checkout">
                                <p>Total </p>
                                {billInfo && billInfo.totalAmount ? (
                                  <p>${billInfo.totalAmount.toFixed(2)}</p>
                                ) : (
                                  <Skeleton width={50} height={28} />
                                )}
                              </div>
                            )}

                            {selectedPaymentType != "BT" && selectedPaymentType != "TILLGOOGLEPAY" && (
                              <div className="checkout-button pay-now-checkout">
                                <Link className="return-to-cart d-none d-md-block"></Link>
                                <div className="button-effect">
                                  <button
                                    className="btn btn-products btn-addcart"
                                    onClick={handlePayNowClick}
                                    disabled={paybuttonDisabled}
                                  >
                                    {SUBMIT_ORDER.includes(selectedPaymentType) || shippingCode === "TBA"
                                      ? "Submit Order"
                                      : "Pay Now"}
                                  </button>
                                </div>
                              </div>
                            )}
                          </Fragment>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-5 rht-summary" style={{ background: "#F5F5F5" }}>
                <OrderSummaryMain billInfo={billInfo} payonline={false} />
              </div>
            </div>
          </div>
        </section>
      ) : (
        <InvalidReferenceId orderId={effectiveOrderId} />
      )}
    </Fragment>
  );
};
